import React, {useEffect, useState} from "react";
import {Link, useParams} from 'react-router-dom';
import axios from 'axios';
import {baseUrl} from '../Univ.js';
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
// =====================================
// ASSET MOVEMENT COMPONENT
// =====================================
function AssetMovement({equipmentId}) {
    const [movementData, setMovementData] = useState([]);
    useEffect(() => {
        fetchMovementData();
    }, [equipmentId]);
    function fetchMovementData() {
        axios.get(
            `${baseUrl}equip-view/${equipmentId}`
        )
            .then(response => {
                console.log(
                    'MOVEMENT DATA =>',
                    response.data
                );
                setMovementData(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    return (
        <>

            {movementData.length > 0 ? (
                <div className="table-responsive">

                    <table className="erp-table-modern">

                        <thead
                            style={{
                                backgroundColor: '#1bc5ce',
                                color: '#fff'
                            }}
                        >

                        <tr>

                            <th>ID</th>

                            <th>Department</th>

                            <th>User</th>

                            <th>Raised Qty</th>

                            <th>Issued Qty</th>

                            <th>Status</th>

                            <th>Date</th>

                        </tr>

                        </thead>

                        <tbody>

                        {movementData.map((row, index) => (
                            <tr key={index}>

                                <td>
                                    {row.id}
                                </td>

                                <td>

                                    {row.dept
                                        ? row.dept.department
                                        : '-'}

                                </td>

                                <td>
                                    {row.user || '-'}
                                </td>

                                <td>
                                    {row.qty || 0}
                                </td>

                                <td>

                                    {row.issued_qty
                                        ? row.issued_qty
                                        : 0}

                                </td>

                                <td>

                                    {row.issued_qty
                                        ? (
                                            <span
                                                className="badge bg-success"
                                            >
                                                    Allocated
                                                </span>
                                        )
                                        : (
                                            <span
                                                className="badge bg-warning text-dark"
                                            >
                                                    Pending
                                                </span>
                                        )}

                                </td>

                                <td>

                                    {row.add_date
                                        ? row.add_date
                                        : '-'}

                                </td>

                            </tr>
                        ))}

                        </tbody>

                    </table>

                </div>
            ) : (
                <div
                    className="text-center p-5"
                >

                    <h5
                        className="mt-3"
                        style={{
                            color: '#6c757d'
                        }}
                    >
                        No Asset Movement Found
                    </h5>

                </div>
            )}

        </>
    );
}
// =====================================
// ASSET TICKETS COMPONENT
// =====================================
function AssetTickets({equipmentId}) {
    const [ticketData, setTicketData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        fetchTicketData();
    }, [equipmentId]);
    function fetchTicketData() {
        axios.get(
            `${baseUrl}eqp-ticket/${equipmentId}/`
        )
            .then(response => {
                console.log(
                    'ASSET TICKETS =>',
                    response.data
                );
                setTicketData(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }
    const columns = [
        {
            field: 'ticket',
            headerName: 'Ticket ID',
            width: 130,
        },
        {
            field: 'add_date',
            headerName: 'Raised On',
            width: 140,
        },
        {
            field: 'addedby',
            headerName: 'Raised By',
            width: 140,
        },
        {
            field: 'subject',
            headerName: 'Subject',
            width: 220,
        },
        {
            field: 'reason',
            headerName: 'Reason',
            width: 320,
        },
        {
            field: 'priority',
            headerName: 'Priority',
            width: 120,
            renderCell: (params) => {
                const priority = params.value;
                return (
                    <>

                        {priority === 'Low' && (
                            <span className="badge bg-info">

                                {priority}

                            </span>
                        )}

                        {priority === 'Normal' && (
                            <span className="badge bg-primary">

                                {priority}

                            </span>
                        )}

                        {priority === 'High' && (
                            <span className="badge bg-danger">

                                {priority}

                            </span>
                        )}

                    </>
                );
            },
        },
        {
            field: 'open_status',
            headerName: 'Status',
            width: 140,
            renderCell: (params) => {
                const open_status = params.value;
                return (
                    <>

                        {open_status === 0 && (
                            <span className="badge bg-info">

                                Raised

                            </span>
                        )}

                        {open_status === 1 && (
                            <span className="badge bg-primary">

                                Open

                            </span>
                        )}

                        {open_status === 2 && (
                            <span className="badge bg-warning text-dark">

                                In Progress

                            </span>
                        )}

                        {open_status === 3 && (
                            <span className="badge bg-success">

                                Answered

                            </span>
                        )}

                        {open_status === 4 && (
                            <span className="badge bg-danger">

                                Reopened

                            </span>
                        )}

                        {open_status === 5 && (
                            <span className="badge bg-dark">

                                Closed

                            </span>
                        )}

                    </>
                );
            },
        },
    ];
    return (
        <>

            {!isLoading && ticketData.length > 0 ? (
                <div
                    style={{
                        width: '100%'
                    }}
                >

                    <DataGrid

                        className="mt-4"
                        sx={{
                            boxShadow: 4,
                            border: 4,
                            borderColor: 'primary.light',
                            '& .MuiDataGrid-cell:hover': {
                                color: 'primary.main',
                            },
                        }}
                        rows={ticketData}

                        columns={columns}

                        pageSize={10}

                        rowsPerPageOptions={[10, 25, 50]}

                        autoHeight

                        disableRowSelectionOnClick

                        slots={{
                            toolbar: GridToolbar,
                        }}

                    />

                </div>
            ) : (
                <div
                    className="text-center p-5"
                >

                    <h5
                        style={{
                            color: '#6c757d'
                        }}
                    >
                        No Service Tickets Found
                    </h5>

                </div>
            )}

        </>
    );
}
// =====================================
// MAIN PAGE
// =====================================
function AssetDetails() {
    const {id} = useParams();
    const [activeTab, setActiveTab] = useState('details');
    const [registerFormData, setRegisterFormData] = useState({
        supp: '',
        subcat: '',
        hsn: '',
        product: '',
        brand: '',
        model_no: '',
        serial_no: '',
        unit: '',
        pack: '',
        qty: '',
        totqty: '',
        mrp: '',
        pprice: '',
        disc: '',
        sgst: '',
        cgst: '',
        gstamount: '',
        netamount: '',
        uamount: '',
        residual_value: '',
        useful_life_years: 5,
        annual_depreciation: '',
        current_asset_value: '',
        depreciation_method: 'SLM',
        purchase_date: null,
        warranty_start: null,
        warranty_end: null,
        amc_type: '',
        amc_vendor: '',
        amc_start: null,
        amc_end: null,
    });
    // =====================================
    // LOAD DATA
    // =====================================
    useEffect(() => {
        axios.get(`${baseUrl}update-eqp-qty/${id}/`)
            .then(response => {
                const data = response.data;
                console.log('ASSET DETAILS =>', data);
                setRegisterFormData({
                    supp: data.supp ? data.supp.name : '',
                    subcat: data.subcat ? data.subcat.subcat : '',
                    hsn: data.hsn || '',
                    product: data.product || '',
                    brand: data.brand || '',
                    model_no: data.model_no || '',
                    serial_no: data.serial_no || '',
                    unit: data.unit || '',
                    pack: data.pack || '',
                    qty: data.qty || '',
                    totqty: data.totqty || '',
                    mrp: data.mrp || '',
                    pprice: data.pprice || '',
                    disc: data.disc || '',
                    sgst: data.sgst || '',
                    cgst: data.cgst || '',
                    gstamount: data.gstamount || '',
                    netamount: data.netamount || '',
                    uamount: data.uamount || '',
                    residual_value:
                        data.residual_value || '',
                    useful_life_years:
                        data.useful_life_years || 5,
                    annual_depreciation:
                        data.annual_depreciation || '',
                    current_asset_value:
                        data.current_asset_value || '',
                    depreciation_method:
                        data.depreciation_method || 'SLM',
                    purchase_date:
                        data.purchase_date || '',
                    warranty_start:
                        data.warranty_start || '',
                    warranty_end:
                        data.warranty_end || '',
                    amc_type:
                        data.amc_type || '',
                    amc_vendor:
                        data.amc_vendor || '',
                    amc_start:
                        data.amc_start || '',
                    amc_end:
                        data.amc_end || '',
                });
            })
            .catch(error => {
                console.log(error);
            });
    }, [id]);
    // =====================================
    // FORMAT DATE
    // =====================================
    const formatDate = (date) => {
        if (!date) return '-';
        const newDate = new Date(date);
        return newDate.toLocaleDateString('en-GB');
    };
    // =====================================
    // INFO BOX
    // =====================================
    const InfoBox = ({label, value}) => (
        <div className="col-md-3 mb-4">

            <div
                className="p-3 h-100"
                style={{
                    border: '1px solid #e5e5e5',
                    borderRadius: '10px',
                    background: '#f8f9fa'
                }}
            >

                <div
                    style={{
                        fontSize: '13px',
                        color: '#6c757d',
                        marginBottom: '5px',
                        fontWeight: '600'
                    }}
                >
                    {label}
                </div>

                <div
                    style={{
                        fontSize: '16px',
                        fontWeight: '600',
                        color: '#212529',
                        wordBreak: 'break-word'
                    }}
                >
                    {value || '-'}
                </div>

            </div>

        </div>
    );
    return (
        <section className="container-fluid mt-4 mb-5">

            <div className="card shadow border-0">

                <div
                    className="card-header d-flex justify-content-between align-items-center"
                    style={{
                        backgroundColor: '#1bc5ce',
                        color: '#fff'
                    }}
                >

                    <h4 className="mb-0">

                        Asset Details

                    </h4>

                    <Link
                        to={`/edit-eqp/${id}`}
                        className="btn btn-light btn-sm"
                    >
                        Edit Asset
                    </Link>

                </div>

                <div className="card-body">

                    {/* =======================
                        TABS
                    ======================== */}

                    <nav>

                        <div
                            className="nav nav-tabs mb-4"
                            role="tablist"
                        >

                            <button
                                className={`nav-link ${activeTab === 'details' ? 'active border-success' : ''}`}
                                onClick={() => setActiveTab('details')}
                                type="button"
                            >

                                Asset Details

                            </button>

                            <button
                                className={`nav-link ${activeTab === 'movement' ? 'active border-primary' : ''}`}
                                onClick={() => setActiveTab('movement')}
                                type="button"
                            >

                                Asset Movement

                            </button>

                            <button
                                className={`nav-link ${activeTab === 'tickets' ? 'active border-primary' : ''}`}
                                onClick={() => setActiveTab('tickets')}
                                type="button"
                            >

                                Service Tickets

                            </button>

                        </div>

                    </nav>


                    {/* =======================
                        TAB CONTENT
                    ======================== */}

                    <div className="tab-content">


                        {/* =======================
                            TAB 1
                        ======================== */}

                        {activeTab === 'details' && (
                            <div className="tab-pane active">

                                <div className="mb-4">

                                    <h5
                                        className="mb-3"
                                        style={{
                                            color: '#1bc5ce',
                                            fontWeight: '700'
                                        }}
                                    >
                                        Basic Information
                                    </h5>

                                    <div className="row">

                                        <InfoBox
                                            label="Equipment Name"
                                            value={registerFormData.product}
                                        />

                                        <InfoBox
                                            label="Category"
                                            value={registerFormData.subcat}
                                        />

                                        <InfoBox
                                            label="Supplier"
                                            value={registerFormData.supp}
                                        />

                                        <InfoBox
                                            label="HSN"
                                            value={registerFormData.hsn}
                                        />

                                        <InfoBox
                                            label="Brand"
                                            value={registerFormData.brand}
                                        />

                                        <InfoBox
                                            label="Model No"
                                            value={registerFormData.model_no}
                                        />

                                        <InfoBox
                                            label="Serial No"
                                            value={registerFormData.serial_no}
                                        />

                                        <InfoBox
                                            label="Unit"
                                            value={registerFormData.unit}
                                        />

                                    </div>

                                </div>


                                <div className="mb-4">

                                    <h5
                                        className="mb-3"
                                        style={{
                                            color: '#1bc5ce',
                                            fontWeight: '700'
                                        }}
                                    >
                                        Quantity Information
                                    </h5>

                                    <div className="row">

                                        <InfoBox
                                            label="Pack"
                                            value={registerFormData.pack}
                                        />

                                        <InfoBox
                                            label="Qty"
                                            value={registerFormData.qty}
                                        />

                                        <InfoBox
                                            label="Total Qty"
                                            value={registerFormData.totqty}
                                        />

                                    </div>

                                </div>


                                <div className="mb-4">

                                    <h5
                                        className="mb-3"
                                        style={{
                                            color: '#1bc5ce',
                                            fontWeight: '700'
                                        }}
                                    >
                                        Financial Details
                                    </h5>

                                    <div className="row">

                                        <InfoBox
                                            label="Purchase Price"
                                            value={registerFormData.pprice}
                                        />

                                        <InfoBox
                                            label="MRP"
                                            value={registerFormData.mrp}
                                        />

                                        <InfoBox
                                            label="Discount %"
                                            value={registerFormData.disc}
                                        />

                                        <InfoBox
                                            label="SGST %"
                                            value={registerFormData.sgst}
                                        />

                                        <InfoBox
                                            label="CGST %"
                                            value={registerFormData.cgst}
                                        />

                                        <InfoBox
                                            label="GST Amount"
                                            value={registerFormData.gstamount}
                                        />

                                        <InfoBox
                                            label="Net Amount"
                                            value={registerFormData.netamount}
                                        />

                                        <InfoBox
                                            label="Unit Amount"
                                            value={registerFormData.uamount}
                                        />

                                    </div>

                                </div>


                                <div className="mb-4">

                                    <h5
                                        className="mb-3"
                                        style={{
                                            color: '#1bc5ce',
                                            fontWeight: '700'
                                        }}
                                    >
                                        Warranty & AMC
                                    </h5>

                                    <div className="row">

                                        <InfoBox
                                            label="Purchase Date"
                                            value={formatDate(registerFormData.purchase_date)}
                                        />

                                        <InfoBox
                                            label="Warranty Start"
                                            value={formatDate(registerFormData.warranty_start)}
                                        />

                                        <InfoBox
                                            label="Warranty End"
                                            value={formatDate(registerFormData.warranty_end)}
                                        />

                                        <InfoBox
                                            label="AMC Type"
                                            value={registerFormData.amc_type}
                                        />

                                        <InfoBox
                                            label="AMC Vendor"
                                            value={registerFormData.amc_vendor}
                                        />

                                        <InfoBox
                                            label="AMC Start"
                                            value={formatDate(registerFormData.amc_start)}
                                        />

                                        <InfoBox
                                            label="AMC End"
                                            value={formatDate(registerFormData.amc_end)}
                                        />

                                    </div>

                                </div>


                                <div className="mb-4">

                                    <h5
                                        className="mb-3"
                                        style={{
                                            color: '#1bc5ce',
                                            fontWeight: '700'
                                        }}
                                    >
                                        Depreciation Details
                                    </h5>

                                    <div className="row">

                                        <InfoBox
                                            label="Residual Value"
                                            value={registerFormData.residual_value}
                                        />

                                        <InfoBox
                                            label="Useful Life Years"
                                            value={registerFormData.useful_life_years}
                                        />

                                        <InfoBox
                                            label="Depreciation Method"
                                            value={registerFormData.depreciation_method}
                                        />

                                        <InfoBox
                                            label="Annual Depreciation"
                                            value={registerFormData.annual_depreciation}
                                        />

                                        <InfoBox
                                            label="Current Asset Value"
                                            value={registerFormData.current_asset_value}
                                        />

                                    </div>

                                </div>

                            </div>
                        )}


                        {/* =======================
                            TAB 2
                        ======================== */}

                        {activeTab === 'movement' && (
                            <div className="tab-pane active">

                                <div className="card border-0 shadow-sm">

                                    <div
                                        className="card-header"
                                        style={{
                                            backgroundColor: '#f4f9fb'
                                        }}
                                    >

                                        <h5
                                            className="mb-0"
                                            style={{
                                                color: '#1bc5ce',
                                                fontWeight: '700'
                                            }}
                                        >
                                            Asset Movement Tracking
                                        </h5>

                                    </div>

                                    <div className="card-body">

                                        <AssetMovement equipmentId={id}/>

                                    </div>

                                </div>

                            </div>
                        )}


                        {/* =======================
                            TAB 3
                        ======================= */}

                        {activeTab === 'tickets' && (
                            <div className="tab-pane active">

                                <div className="card border-0 shadow-sm">

                                    <div
                                        className="card-header"
                                        style={{
                                            backgroundColor: '#f4f9fb'
                                        }}
                                    >

                                        <h5
                                            className="mb-0"
                                            style={{
                                                color: '#1bc5ce',
                                                fontWeight: '700'
                                            }}
                                        >
                                            Asset Service Tickets
                                        </h5>

                                    </div>

                                    <div className="card-body">

                                        <AssetTickets equipmentId={id}/>

                                    </div>

                                </div>

                            </div>
                        )}

                    </div>

                </div>

            </div>

        </section>
    );
}
export default AssetDetails;